import { useRef, useState } from "react";
import moment from "moment";

export const useAllTransactionsList = (
  initialAllSales = [],
  ITEMS_PER_PAGE,
) => {
  const isFirstRender = useRef(true);
  const firstRender = isFirstRender.current;

  const initialData =
    firstRender && initialAllSales?.length
      ? initialAllSales.slice(0, ITEMS_PER_PAGE)
      : [];

  const [state, setState] = useState({
    isLoading: true,
    transactionsList: initialData,
    totalPaid: 0,
    totalUnPaid: 0,
    totalTransactionsFilterCount: 0,
    totalTransactionsAmount: 0,
  });

  const getDateRange = (date) => {
    return {
      start: date?.startDate
        ? moment(date.startDate).startOf("day").valueOf()
        : undefined,
      end: date?.endDate
        ? moment(date.endDate).endOf("day").valueOf()
        : undefined,
    };
  };

  const calculateTotals = (data) => {
    let totals = {
      totalFilteredCount: data?.length || 0,
      totalPaid: 0,
      totalUnPaid: 0,
      totalTransactionsAmount: 0,
    };

    data.forEach((item) => {
      totals.totalTransactionsAmount += item.amount;

      if (item.status === "paid") {
        totals.totalPaid += item.amount;
      } else {
        totals.totalUnPaid += item.amount - (item.advance_amount || 0);
      }
    });
    return totals;
  };

  const handleAllTransactions = async ({
    business,
    filters,
    limit,
    offset,
    isCalculateTotal = true,
  }) => {
    const { date, amount, sort, type, keywords,status,method } = filters || {};

    setState((prev) => ({ ...prev, isLoading: true }));

    const { start, end } = getDateRange(date);

    try {
      let totals = {};

      // Calculate totals
      if (isCalculateTotal) {
        let rawData;

        if (firstRender) {
          rawData = initialAllSales;
        } else {
          const baseQuery = business.getAllRecentTransactions(
            start,
            end,
            keywords || "",
            undefined,
            undefined,
            undefined,
            amount,
            type,
            status,
            method
          );

          rawData = await baseQuery.unsafeFetchRaw();
        }

        totals = calculateTotals(rawData);
      }

      // Fetch paginated list
      const paginatedItems = firstRender
        ? initialData
        : await business
            .getAllRecentTransactions(
              start,
              end,
              keywords || "",
              limit,
              offset,
              sort || "Newest",
              amount,
              type,
              status,
              method
            )
            .fetch();

      const updatedList =
        offset > 0 ? [...state.transactionsList, ...paginatedItems] : paginatedItems;

      isFirstRender.current = false;

      setState((prev) => ({
        ...prev,
        isLoading: false,
        transactionsList: updatedList,
        ...(isCalculateTotal && {
          totalPaid: totals.totalPaid,
          totalUnPaid: totals.totalUnPaid,
          totalTransactionsFilterCount: totals.totalFilteredCount,
          totalTransactionsAmount: totals.totalTransactionsAmount,
        }),
      }));
    } catch (error) {
      console.error(error);
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  return { ...state, handleAllTransactions };
};
